module.exports = "../dist/frontend/icons/logo/loader.svg?dfdf122c6fa3fd8c7cd012e1d595b7ca";